export const API_URL = 'https://admin-api.thantai68.net';
export default API_URL;
